import { scheduleTour } from '@/utils/tour';

const EXTERNAL_ID_EVENT = 'Sign Up Error - externalId';
const CLEAR_EVENT = 'Clear Sign Up Validations';

export default {
  data() {
    return {
      errors: {},
      email: '',
      firstName: '',
      invalid: {},
      lastName: '',
      loading: false,
      message: '',
      password: '',
    };
  },
  computed: {
    authenticated() {
      return this.$store.getters['session/authenticated'];
    },
    certApp() {
      return this.$store.getters['certifications/certificationsList'].length > 0;
    },
    ready() {
      return this.email.length > 0 && this.password.length > 0 && !this.loading;
    },
  },
  methods: {
    addInvalid(type) {
      this.invalid[type] = true;
    },
    clearAuthenticationErrors() {
      this.$eventBus.$emit(CLEAR_EVENT);
      this.errors = {};
    },
    collectTrackingParams() {
      // gather tracking params from authoritative source in session store & place in params object
      let trackingParams = {};
      this.$store.getters['session/trackingAttributes'].map(item => {
        trackingParams[item] = this.$cookies.get(item) || '';
      });
      return trackingParams;
    },
    handleErrors(e) {
      if (e.response && e.response.data && e.response.data.errors) {
        let errors = e.response.data.errors;
        Object.keys(errors).map(field => {
          if (field === 'externalId') {
            let error = errors[field];
            let message;
            if (typeof(error) == 'string') {
              message = errors[field];
            } else {
              message = errors[field][0];
            }
            this.$eventBus.$emit(EXTERNAL_ID_EVENT, message);
          } else {
            this.errors[field] = `${field[0].toUpperCase()}${field.slice(1)} ${errors[field][0]}`;
          }
        });
      } else {
        this.message = 'An error occurred, please contact support';
        setTimeout(() => { this.message = ''; }, 4000);
        return Promise.reject(e);
      }
    },
    handleInputChange(value, field) {
      this[field] = value;
    },
    postSignUp() {
      // iterate through tracking params and delete - can delete since backend handles them now
      this.$store.dispatch('session/deleteTrackingCookies');
      // if user should enter tour post sign up
      scheduleTour(this.$store);
      this.redirectAfterSignIn();
    },
    redirectAfterSignIn() {
      const redirectAfterLogin = this.$cookies.get('redirectAfterLogin');

      if (redirectAfterLogin) {
        this.$router.push(decodeURI(redirectAfterLogin)).then(() => {
          this.$cookies.remove('redirectAfterLogin');
        });
      } else {
        this.$router.push({ name: 'home' });
      }
    },
    removeInvalid(type) {
      this.invalid[type] = false;
    },
  },
};
